module.exports = __webpack_public_path__ + "static/media/annoyed-alt.25d27b9b.svg";